<!-- Meta Bar -->
<div class="meta-bar meta-bar--loader">
  <ngx-skeleton-loader
    [theme]="{
      width: '100%',
      height: '100%',
      'margin-bottom': '0',
      'background-color': '#f9f9fa',
    }"
  ></ngx-skeleton-loader>
  <div class="container h-100 loader-box">
    <div class="meta-bar__row">
      <div class="meta-bar__row__section">
        <div
          class="meta-bar__row__section__item meta-bar__row__section__item--loader"
          *ngFor="let item of [].constructor(5)"
        >
          <ngx-skeleton-loader
            [theme]="{
              width: '100%',
              height: '100%',
              'margin-bottom': '0',
            }"
          ></ngx-skeleton-loader>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Meta Bar -->
<!-- Top Bar -->
<div class="top-bar">
  <ngx-skeleton-loader
    [theme]="{
      width: '100%',
      height: '100%',
      'margin-bottom': '0',
      'background-color': '#f9f9fa',
    }"
  ></ngx-skeleton-loader>
  <div class="top-bar__row top-bar__row--loader container">
    <div class="top-bar__row__section top-bar__row__section--logo">
      <div class="logo-img-loader">
        <ngx-skeleton-loader
          [theme]="{
            width: '100%',
            height: '100%',
            'margin-bottom': '0',
            position: 'absolute',
            top: '0',
          }"
        ></ngx-skeleton-loader>
      </div>
      <div class="logo-text-loader">
        <ngx-skeleton-loader
          [theme]="{
            width: '100%',
            height: '100%',
            'margin-bottom': '0',
            position: 'absolute',
            top: '0',
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
    <!-- Menu Desktop -->
    <div class="top-bar__row__section top-bar__row__section--main-nav">
      <div
        class="top-bar__row__section--main-nav__item"
        *ngFor="let item of [].constructor(5)"
      >
        <div class="nav-item-loader">
          <ngx-skeleton-loader
            [theme]="{
              width: '100%',
              height: '100%',
              'margin-bottom': '0',
              position: 'absolute',
              top: '0',
            }"
          ></ngx-skeleton-loader>
        </div>
      </div>
    </div>
    <div class="top-bar__row__section top-bar__row__section--search">
      <div class="nav-login-loader">
        <ngx-skeleton-loader
          [theme]="{
            width: '100%',
            height: '100%',
            'margin-bottom': '0',
            position: 'absolute',
            top: '0',
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
    <!-- End Menu Desktop -->
    <!-- Menu Mobile -->
    <div
      class="top-bar__row__section top-bar__row__section--mobile top-bar__row__section--mobile-loader"
    >
      <div class="nav-icon-loader">
        <ngx-skeleton-loader
          [theme]="{
            width: '100%',
            height: '100%',
            'margin-bottom': '0',
            position: 'absolute',
            top: '0',
          }"
        ></ngx-skeleton-loader>
      </div>
      <div class="nav-icon-loader">
        <ngx-skeleton-loader
          [theme]="{
            width: '100%',
            height: '100%',
            'margin-bottom': '0',
            position: 'absolute',
            top: '0',
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
    <!-- End Menu Mobile -->
  </div>
</div>
<!-- End Top Bar -->
